<a *ngIf="scroll" href="#" (click)="topFunction($event)" id="back-to-top" class="back-to-top fixed text-lg rounded-full z-10 bottom-5 start-5 h-9 w-9 text-center bg-violet-600 text-white leading-9"><i class="uil uil-arrow-up"></i></a>
